import useBaseSize from '@/hooks/useBaseSize';
import { useOrientation } from '@/hooks/useOrientation';
import { useConfigStore } from '@/stores';
import { getHSize, getSize } from '@/utils/size';
import type { ReactNode } from 'react';
import { useMemo } from 'react';
import styles from './styles.module.scss';

interface EventPageLayoutProps {
    children: ReactNode;
}

export default function EventPageLayout({ children }: EventPageLayoutProps) {
    const screenMode = useConfigStore((state) => state.config?.ui?.screenMode);
    const { isHorizontal } = useOrientation();
    const { baseWidth, baseHeight } = useBaseSize();
    const isHalfScreen = screenMode === 'split';

    const layoutStyle = useMemo(() => {
        const halfTopPad = isHorizontal ? getHSize(171, baseHeight) : getHSize(868, baseHeight);

        return {
            paddingTop: isHalfScreen ? halfTopPad : '0',
            maxWidth: `${getSize(1920, baseWidth)}`,
        };
    }, [isHalfScreen, isHorizontal, baseWidth, baseHeight]);

    return (
        <div className={styles.layout} style={layoutStyle}>
            {children}
        </div>
    );
}
